/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Image_Inspector_IsoInputs */

const en_image_inspector_iso = /** @type {(inputs: Image_Inspector_IsoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ISO`)
};

const ar_image_inspector_iso = /** @type {(inputs: Image_Inspector_IsoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ISO`)
};

const bn_image_inspector_iso = /** @type {(inputs: Image_Inspector_IsoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ISO`)
};

const de_image_inspector_iso = /** @type {(inputs: Image_Inspector_IsoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ISO`)
};

const es_image_inspector_iso = /** @type {(inputs: Image_Inspector_IsoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ISO`)
};

const fr_image_inspector_iso = /** @type {(inputs: Image_Inspector_IsoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ISO`)
};

const pt_image_inspector_iso = /** @type {(inputs: Image_Inspector_IsoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ISO`)
};

const zh_image_inspector_iso = /** @type {(inputs: Image_Inspector_IsoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ISO`)
};

const tr_image_inspector_iso = /** @type {(inputs: Image_Inspector_IsoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ISO`)
};

const ru_image_inspector_iso = /** @type {(inputs: Image_Inspector_IsoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ISO`)
};

const pl_image_inspector_iso = /** @type {(inputs: Image_Inspector_IsoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ISO`)
};

/**
* | output |
* | --- |
* | "ISO" |
*
* @param {Image_Inspector_IsoInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const image_inspector_iso = /** @type {((inputs?: Image_Inspector_IsoInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Image_Inspector_IsoInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_image_inspector_iso(inputs)
	if (locale === "bn") return bn_image_inspector_iso(inputs)
	if (locale === "de") return de_image_inspector_iso(inputs)
	if (locale === "es") return es_image_inspector_iso(inputs)
	if (locale === "fr") return fr_image_inspector_iso(inputs)
	if (locale === "pt") return pt_image_inspector_iso(inputs)
	if (locale === "zh") return zh_image_inspector_iso(inputs)
	if (locale === "tr") return tr_image_inspector_iso(inputs)
	if (locale === "ru") return ru_image_inspector_iso(inputs)
	if (locale === "pl") return pl_image_inspector_iso(inputs)
	return en_image_inspector_iso(inputs)
});